import {
  ROUTES,
  TravelStartTabs,
  Subscriptions,
  categoryKeys,
  DirectorViews,
  menuItemNames,
} from "@Src/constants";

// START HARDCODED CATEROGIES
export const groceryCategory = {
  category_key: categoryKeys.GROCERY_COUPONS,
  category_name: menuItemNames.GROCERY_COUPONS,
  category_parent_key: categoryKeys.EAT,
  route: `${ROUTES.DIRECTOR_PATH}?view=${DirectorViews.SEARCH}&keyword=grocery`,
};

export const hotDealsCategory = {
  category_key: categoryKeys.HOT_DEALS,
  category_name: menuItemNames.HOT_DEALS,
  category_parent_key: 0,
};

// Travel tabs in CatMenu, not actual categories
export const generalTravelCategory = {
  category_key: categoryKeys.TRAVEL,
  category_name: menuItemNames.TRAVEL,
  category_parent_key: 0,
  route: ROUTES.TRAVEL_PATH,
  start_tab: [
    TravelStartTabs.HOTELS,
    TravelStartTabs.CARS,
    TravelStartTabs.FLIGHTS,
    TravelStartTabs.ACTIVITIES,
    TravelStartTabs.EVENTS,
  ],
};
export const travelTabCategories = {
  activities: {
    category_key: categoryKeys.ACTIVITIES,
    category_name: menuItemNames.ACTIVITIES,
    category_parent_key: 0,
    route: ROUTES.ACTIVITIES_PATH,
    start_tab: TravelStartTabs.ACTIVITIES,
  },
  cars: {
    category_key: categoryKeys.CARS,
    category_name: menuItemNames.CAR_RENTAL,
    category_parent_key: 0,
    route: ROUTES.CARS_PATH,
    start_tab: TravelStartTabs.CARS,
  },
  cruise: {
    category_key: categoryKeys.CRUISE,
    category_name: menuItemNames.CRUISE,
    category_parent_key: 0,
    route: ROUTES.TRAVEL_PATH,
    start_tab: TravelStartTabs.CRUISE,
  },
  events: {
    category_key: categoryKeys.EVENTS,
    category_name: menuItemNames.EVENTS,
    category_parent_key: 0,
    route: ROUTES.EVENTS_PATH,
    start_tab: TravelStartTabs.EVENTS,
  },
  flights: {
    category_key: categoryKeys.FLIGHTS,
    category_name: menuItemNames.FLIGHTS,
    category_parent_key: 0,
    route: ROUTES.FLIGHTS_PATH,
    start_tab: TravelStartTabs.FLIGHTS,
  },
  hotels: {
    category_key: categoryKeys.HOTELS,
    category_name: menuItemNames.HOTELS,
    category_parent_key: 0,
    route: ROUTES.HOTELS_PATH,
    start_tab: TravelStartTabs.HOTELS,
  },
  theme: {
    // sent from api as theme_park_tab_enabled, but gets truncated/split down to just `theme` in the categoryMappers
    // activeTravelTabs construct method - `activeTab.split("_")[0]`, specifically.
    category_key: categoryKeys.THEMEPARKS,
    category_name: menuItemNames.THEME_PARKS,
    category_parent_key: 0,
    route: ROUTES.PARKS_PATH,
    start_tab: TravelStartTabs.PARKS,
  },
};

// END HARDCODED CATEGORIES

export const categoryMapper = (apiResponse, travelTabs = {}, programKey = null) => {
  const categories = [...(apiResponse.hasOwnProperty("categories") ? apiResponse.categories : [])];
  const mapNameAndRedirect = (category) => {
    switch (category.category_name) {
      case "Dining & Food":
        category.ui_name = menuItemNames.EAT;
        break;
      case "Hotel":
        category.ui_name = menuItemNames.HOTELS;
        category.route = "/travel";
        break;
      case "Entertainment & Recreation":
        category.ui_name = menuItemNames.PLAY;
        break;
      case "Shopping":
        category.ui_name = menuItemNames.SHOP;
        break;
      case "Activities":
        category.ui_name = menuItemNames.THINGS_TO_DO;
        break;
      case "Grocery Coupons":
        category.route = groceryCategory.route;
        break;
      default:
        return;
    }
  };

  const handleHotDealsCategory = () => {
    const { subscription } = apiResponse?.info;
    if (subscription.includes("shop") || subscription.includes("basic")) {
      categories.push(hotDealsCategory);
    }
  };

  const handleGroceryCoupons = () => {
    // Add the hard coded grocery coupon category
    if (
      categories.filter((cat) => cat.category_name === menuItemNames.GROCERY_COUPONS).length === 0
    ) {
      categories.push(groceryCategory);
    }
  };

  const handleTravelCategories = () => {
    if (!!travelTabs) {
      // Add travel categories based on which travel tabs are active from the API
      const activeTravelTabs = Object.keys(travelTabs)
        .filter((tab) => travelTabs[tab])
        .map((activeTab) => travelTabCategories[activeTab.split("_")[0]]);
      let isThemeParksOnly = false;
      if (
        activeTravelTabs?.length === 1 &&
        activeTravelTabs[0]?.category_key === categoryKeys.THEMEPARKS
      ) {
        isThemeParksOnly = true;
      }
      if (!!activeTravelTabs.length && !isThemeParksOnly) {
        activeTravelTabs.push(generalTravelCategory);
      }

      activeTravelTabs.forEach(function (tab) {
        categories.push(tab);
      });
    }
  };

  const setRootandSubCategories = () => {
    // Root categories: Map special keys and filter categories based on subscription
    const rootCategories = categories.reduce((accum, category) => {
      const { subscription } = apiResponse?.info;
      let subscriptionCategories = [categoryKeys.EAT, categoryKeys.PLAY, categoryKeys.SHOP];
      if (category.category_parent_key === 0) {
        // Add UI name and redirect path
        mapNameAndRedirect(category);
        category.subcategories = [];

        // Make sure root category is also in the subscription
        if (subscriptionCategories.includes(category.category_key)) {
          // Subscription response from categories api should either include the category ui_name (eat , play, shop) or basic
          const shouldAddCategory =
            subscription.includes(category.ui_name?.toLowerCase()) ||
            subscription.includes(Subscriptions.TRANSACTIONAL.toLowerCase()) ||
            subscription.includes(Subscriptions.BASIC.toLowerCase());

          if (shouldAddCategory) {
            accum.push(category);
          }
        } else {
          accum.push(category);
        }
      }

      return accum;
    }, []);

    // Maps subcategories to root categories
    categories.forEach((category) => {
      rootCategories.forEach((rootCategory) => {
        if (rootCategory.category_key === category.category_parent_key) {
          rootCategory.subcategories.push(category);
        }

        // Sort subcats in alphabetical order
        rootCategory.subcategories.sort((a, b) => a.category_name.localeCompare(b.category_name));
      });
    });

    return rootCategories;
  };
  handleHotDealsCategory();

  handleGroceryCoupons();

  handleTravelCategories();

  const rootCategories = setRootandSubCategories();

  return {
    info: apiResponse.info,
    categories: [...rootCategories],
  };
};

export const sortedCategoriesByKey = (sortedCatKeys, categories) => {
  const filteredCats = categories.reduce((accum, cat) => {
    if (sortedCatKeys.includes(cat.category_key)) {
      accum.push(cat);
    }
    if (!!cat.subcategories?.length) {
      for (let subcat of cat.subcategories) {
        if (sortedCatKeys.includes(subcat?.category_key)) {
          accum.push(subcat);
        }
      }
    }
    return accum;
  }, []);

  const sortedCats = filteredCats.sort(
    (a, b) => sortedCatKeys.indexOf(a.category_key) - sortedCatKeys.indexOf(b.category_key),
  );

  return sortedCats;
};
